import { cn, Popup as PopupUI } from '@divlab/divanui';

import useTranslation from '@Queries/useTranslation';
import styles from './Popup.module.css';

import type { FC } from 'react';
import type { PopupProps } from '@divlab/divanui';

const Popup: FC<PopupProps> = (props) => {
  const { className, ...restProps } = props;
  const { t } = useTranslation();

  return (
    <PopupUI {...restProps} data-testid='information-bonus' className={cn(styles.main, className)}>
      <p className={styles.text}>{t('ui.cashback-tag.popup')}</p>
    </PopupUI>
  );
};

export default Popup;
